module.exports = __webpack_public_path__ + "static/portfolio-personal-41ee863000f394b9da98094e6ebe2065.jpg";